"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFaviconUrl = exports.getThemeAssetNameAndLastModifiedFromURL = exports.getThemeAssetURL = exports.convertDimensions = exports.buildBasePath = void 0;
const SwitchBranchHelper_1 = require("../developer/SwitchBranchHelper");
const assets_1 = require("@aurora/shared-types/assets");
const path_to_regexp_1 = require("path-to-regexp");
const UrlBuilder_1 = __importDefault(require("../urls/UrlHelper/UrlBuilder"));
const UrlHelper_1 = require("../urls/UrlHelper/UrlHelper");
function buildBasePath(urlPathCallback, assetParams) {
    const { servicePathChar, contextName } = assetParams;
    return urlPathCallback(Object.assign(Object.assign({}, assetParams), { contextName: servicePathChar ? contextName : null }));
}
exports.buildBasePath = buildBasePath;
const THEME_ASSET_URL = '/:contextName?/:servicePathChar?/:community?/m_assets/themes/:themeId/:assetName';
const themeUrlMatchCallback = (0, path_to_regexp_1.match)(THEME_ASSET_URL, {
    decode: decodeURIComponent,
    start: false
});
const themeUrlPathCallback = (0, path_to_regexp_1.compile)(THEME_ASSET_URL, {
    encode: UrlHelper_1.safeEncodeUriComponent
});
/**
 * Convert the specified dimensions to a param string
 *
 * @param dimensions
 */
function convertDimensions(dimensions) {
    return `${dimensions.width}x${dimensions.height}`;
}
exports.convertDimensions = convertDimensions;
/**
 * Returns the asset url
 *
 * @param tenant the current tenant
 * @param themeId the theme id
 * @param assetName the asset name
 * @param timestamp the asset timestamp
 * @param dimensions  the custom dimension. e.g. "30x30"
 * @param branchName if not on the main branch, the branch name
 */
function getThemeAssetURL(tenant, themeId, assetName, timestamp, dimensions, branchName) {
    var _a;
    if (themeId && assetName) {
        const { community, liaContextPath } = tenant;
        const [, contextName, servicePathChar] = (_a = liaContextPath === null || liaContextPath === void 0 ? void 0 : liaContextPath.split('/')) !== null && _a !== void 0 ? _a : [];
        const basePath = buildBasePath(themeUrlPathCallback, {
            contextName,
            servicePathChar,
            community,
            themeId,
            assetName
        });
        const url = UrlBuilder_1.default.fromUrl(basePath);
        if (timestamp != null) {
            url.addQuery({ time: timestamp });
        }
        if (dimensions) {
            url.addQuery({ 'image-dimensions': convertDimensions(dimensions) });
        }
        if ((0, SwitchBranchHelper_1.isCustomizationBranch)(tenant, branchName)) {
            url.addQuery({ 'assets.branch': branchName });
        }
        if (process.env.NEXT_PUBLIC_URL_USE_HOST_IN_SERVLET_URL) {
            url.uri.host(tenant.host);
        }
        return url.build();
    }
    return null;
}
exports.getThemeAssetURL = getThemeAssetURL;
/**
 * Gets the theme asset name and theme last modified time from the specified URL.
 *
 * @param tenant the tenant
 * @param themeId the theme ID
 * @param url the URL to get the theme asset name and last modified time from
 */
function getThemeAssetNameAndLastModifiedFromURL(tenant, themeId, url) {
    var _a, _b, _c;
    if (url) {
        const { uri } = UrlBuilder_1.default.fromUrl(url);
        const matcher = themeUrlMatchCallback(uri.path());
        if (matcher) {
            const { assetName } = matcher.params;
            return { assetName, lastModified: (_c = (_b = (_a = uri.query()) === null || _a === void 0 ? void 0 : _a.time) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : null };
        }
    }
    return null;
}
exports.getThemeAssetNameAndLastModifiedFromURL = getThemeAssetNameAndLastModifiedFromURL;
/**
 * Get the favicon URL based on the current theme. If no icon is set
 * in the theme, it will fall back to a default.
 *
 * @param theme the theme
 * @param tenant the tenant
 * @param faviconVersion the favicon version for the default icon
 * @param dimensions the dimensions
 * @param branchName if not on the main branch, the branch name
 */
function getFaviconUrl(theme, tenant, faviconVersion, dimensions, branchName) {
    var _a, _b, _c, _d, _e, _f;
    const imageAssetName = (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.basics) === null || _a === void 0 ? void 0 : _a.browserIcon) === null || _b === void 0 ? void 0 : _b.imageAssetName) !== null && _c !== void 0 ? _c : '';
    const imageLastModified = (_f = (_e = (_d = theme === null || theme === void 0 ? void 0 : theme.basics) === null || _d === void 0 ? void 0 : _d.browserIcon) === null || _e === void 0 ? void 0 : _e.imageLastModified) !== null && _f !== void 0 ? _f : assets_1.LastModifiedKeys.DEFAULTS_ONLY;
    if (imageAssetName.length > 0 && imageLastModified !== assets_1.LastModifiedKeys.DEFAULTS_ONLY) {
        const url = getThemeAssetURL(tenant, theme.id, imageAssetName, imageLastModified, dimensions, branchName);
        if (url) {
            return url;
        }
    }
    return (0, UrlHelper_1.prefixStaticAsset)(`/static/favicons/${faviconVersion}/favicon-${convertDimensions(dimensions)}.png`);
}
exports.getFaviconUrl = getFaviconUrl;
//# sourceMappingURL=ThemeAssetHelper.js.map